import { Card, Stack, Typography } from '@mui/material';
import React from 'react'

const TabContent = ({title, content, image }) => {
    return (
    <Stack
    spacing={3}
    alignItems="flex-start"
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      gap: "20px",
      width: "100%",
    }}
  >
    {/* Text Section */}
    <Card
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        width: { xs: "100%", md: "auto" },
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontWeight: "800",
          fontSize: { xs: "20px", md: "40px" }, // Smaller on mobile
          color: "#000000",
          lineHeight: "120%",
          letterSpacing: "2%",
          paddingBottom: { xs: "4%", md: "8%" }, // Less padding on mobile
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: "normal",
          fontSize: { xs: "14px", md: "25px" }, // Smaller font on mobile
          color: "#000000",
        }}
      >
        {content}
      </Typography>
    </Card>

    {/* Image Section */}
    <Card
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        width: { xs: "100%", md: "50%" }, // Full width on mobile, 50% on desktop
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        src={image}
        alt={title}
        style={{
          height: "auto",
          width: "100%", // Responsive width
          maxWidth: "300px", // Optional max size for better scaling
          margin: "0 auto", // Centered on mobile
          objectFit: "cover",
        }}
      />
    </Card>
  </Stack>
);
}

export default TabContent